// import Swiper JS
import Swiper from 'swiper';
// import Swiper styles
import "swiper/css/swiper.css"

jQuery(document).on('turbolinks:load', function(){
  var swiper = new Swiper('.swiper', {
    // Optional parameters
    loop: true,
    speed: 800,
    slidesPerView: 1.3,
    centeredSlides : true,
    // spaceBetween: 80,

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })
});
